const UserRoles = {
	Admin: 10,
	Financial: 13,
	Executive: 15,
	Manager: 20,
	TORManager: 21,
	Collection: 24,
	HelpDesk: 25,
	Hiring: 26,
	Dispatch: 30,
	FieldEngineer: 40,
	Developer: 50,
	Feedback: 60,
	Projects: 90,
	Hidden: 100,
	Onboarding: 500,

	10: 'Admin',
	13: 'Financial',
	15: 'Executive',
	20: 'Manager',
	21: 'TOR Manager',
	24: 'Collection',
	25: 'HelpDesk',
	26: 'Hiring',
	30: 'Dispatch',
	40: 'Field Engineer',
	50: 'Developer',
	60: 'Feedback',
	90: 'Projects',
	100: 'Hidden',
	500: 'Onboarding'
};

/** Admin, Executive, Manager, TOR Manager - can open other user profiles / managerial fields */
export const MANAGER_PLUS_ROLES = [
	UserRoles.Admin,
	UserRoles.Executive,
	UserRoles.Manager,
	UserRoles.TORManager,
];

/** Manager+ plus Financial — users directory, other profiles, DD review */
export const USER_DIRECTORY_ROLES = [
	...MANAGER_PLUS_ROLES,
	UserRoles.Financial,
];

export default UserRoles;